import { Graphics, settings } from 'pixi.js-legacy';
export default class Textures {
    constructor() {
        this.resolution = 10;
        this.scale = 2;
        this.graphics = new Graphics();
    }
    static getInstance() {
        if (!Textures._instance) {
            Textures._instance = new Textures();
        }
        return Textures._instance;
    }
    destroy() {
        Textures._instance = undefined;
    }
    LoadTextures(pixiRenderer) {
        this.loadDecking(pixiRenderer);
        this.loadColumns(pixiRenderer);
        this.loadUi(pixiRenderer);
    }
    loadDecking(pixiRenderer) {
        this.graphics.clear();
        this.graphics.beginFill(0xffc694, 0.5);
        this.graphics.drawRect(0, 0, 40 * this.scale, 40 * this.scale);
        this.graphics.endFill();
        this.deck = pixiRenderer.generateTexture(this.graphics, {
            scaleMode: settings.SCALE_MODE,
            resolution: this.resolution,
        });
        this.graphics.clear();
    }
    loadColumns(pixiRenderer) {
        this.graphics.clear();
        const innerRadius = 8 * this.scale;
        const outerRadius = 10 * this.scale;
        const centre = 12 * this.scale;
        this.graphics.lineStyle(4 * this.scale, 0x000000, 1);
        this.graphics.drawCircle(centre, centre, outerRadius);
        this.columnDiagram = pixiRenderer.generateTexture(this.graphics, {
            scaleMode: settings.SCALE_MODE,
            resolution: this.resolution,
        });
        this.graphics.clear();
        this.graphics.lineStyle(4 * this.scale, 0xff0000, 0.8);
        this.graphics.drawCircle(centre, centre, outerRadius);
        this.graphics.lineStyle(4 * this.scale, 0x000000, 1);
        this.graphics.drawCircle(centre, centre, innerRadius);
        this.columnDiagramSelected = pixiRenderer.generateTexture(this.graphics, {
            scaleMode: settings.SCALE_MODE,
            resolution: this.resolution,
        });
        this.graphics.clear();
        this.graphics.lineStyle(1 * this.scale, 0xe50000, 1);
        this.graphics.beginFill(0x000000, 0);
        this.graphics.drawRect(2 * this.scale, 2 * this.scale, 20 * this.scale, 20 * this.scale);
        this.graphics.drawRect(6 * this.scale, 6 * this.scale, 12 * this.scale, 12 * this.scale);
        this.graphics.endFill();
        this.graphics.moveTo(12 * this.scale, 0);
        this.graphics.lineTo(12 * this.scale, 24 * this.scale);
        this.graphics.moveTo(0, 12 * this.scale);
        this.graphics.lineTo(24 * this.scale, 12 * this.scale);
        this.designColumn = pixiRenderer.generateTexture(this.graphics, {
            scaleMode: settings.SCALE_MODE,
            resolution: this.resolution,
        });
        this.graphics.clear();
        this.graphics.lineStyle(4 * this.scale, 0xe50000, 1);
        this.graphics.beginFill(0x000000, 0);
        this.graphics.drawRect(2 * this.scale, 2 * this.scale, 20 * this.scale, 20 * this.scale);
        this.graphics.lineStyle(1 * this.scale, 0xe50000, 1);
        this.graphics.drawRect(6 * this.scale, 6 * this.scale, 12 * this.scale, 12 * this.scale);
        this.graphics.endFill();
        this.graphics.moveTo(12 * this.scale, 0);
        this.graphics.lineTo(12 * this.scale, 24 * this.scale);
        this.graphics.moveTo(0, 12 * this.scale);
        this.graphics.lineTo(24 * this.scale, 12 * this.scale);
        this.designColumnSelected = pixiRenderer.generateTexture(this.graphics, {
            scaleMode: settings.SCALE_MODE,
            resolution: this.resolution,
        });
        this.graphics.clear();
    }
    loadUi(pixiRenderer) {
        this.graphics.clear();
        const lineLength = 5;
        const outerRadius = 8 * this.scale;
        const innerRadius = 6 * this.scale;
        const centre = outerRadius + lineLength;
        this.graphics.lineStyle(1 * this.scale, 0x000000, 1);
        this.graphics.drawCircle(centre, centre, outerRadius);
        this.graphics.moveTo(centre, centre);
        this.graphics.lineTo(centre + outerRadius + lineLength, centre);
        this.graphics.moveTo(centre, centre);
        this.graphics.lineTo(centre - outerRadius - lineLength, centre);
        this.graphics.moveTo(centre, centre);
        this.graphics.lineTo(centre, centre + outerRadius + lineLength);
        this.graphics.moveTo(centre, centre);
        this.graphics.lineTo(centre, centre - outerRadius - lineLength);
        this.graphics.lineStyle(0);
        this.graphics.beginFill(0x000000, 1);
        this.graphics.drawCircle(centre, centre, innerRadius);
        this.graphics.endFill();
        this.centerButton = pixiRenderer.generateTexture(this.graphics, {
            scaleMode: settings.SCALE_MODE,
            resolution: this.resolution,
        });
        this.graphics.clear();
    }
    get CenterButton() {
        return this.centerButton;
    }
    get ColumnDiagrammatic() {
        return this.columnDiagram;
    }
    get ColumnDiagrammaticSelected() {
        return this.columnDiagramSelected;
    }
    get ColumnDesign() {
        return this.designColumn;
    }
    get ColumnDesignSelected() {
        return this.designColumnSelected;
    }
    get Decking() {
        return this.deck;
    }
}
